const LongArrowDown = () => {
  return (
    <svg
      width='9'
      height='51'
      viewBox='0 0 9 51'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        id='Arrow 16'
        d='M4.18942 50.3536C4.38468 50.5488 4.70126 50.5488 4.89652 50.3536L8.0785 47.1716C8.27376 46.9763 8.27376 46.6597 8.0785 46.4645C7.88324 46.2692 7.56666 46.2692 7.3714 46.4645L4.54297 49.2929L1.71454 46.4645C1.51928 46.2692 1.2027 46.2692 1.00743 46.4645C0.812173 46.6597 0.812173 46.9763 1.00743 47.1716L4.18942 50.3536ZM4.04297 0L4.04297 50H5.04297L5.04297 0L4.04297 0Z'
        fill='#9FCDD7'
      />
    </svg>
  )
}

export default LongArrowDown
